import React, { useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";

import AngularImg from "../../assets/images/courses/angular.jpg";
import { FaPlay } from "react-icons/fa6";

import "./styles.scss";

import Button from "../Button";
import parse from "html-react-parser";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../store2/features/cartSlice";
import { useNavigate } from "react-router-dom";
import { FaCartArrowDown } from "react-icons/fa6";
import { callAlert, downloadPdfFile } from "../../services/CommonService";
import { toast } from "react-toastify";
import { setTrailDetails, subscriptionTrial } from "../../services/AuthService";

export default function TrainingCourseBanner(props) {
  const {
    name,
    summary,
    ratings,
    price,
    discount,
    course,
    notify,
    userDetails,
    handleAddToCartFreeTrial,
  } = props;
  // =============Breadcrumb Path======
  const path = [
    { text: "Home", path: "/" },
    { text: "course", path: "/" },
    { text: "GRADE 11th ICSE (ICSE)" }, // No path for the active page
  ];

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.items);
  const userDetailss = localStorage.getItem("userDetails");

  const handleAddToCart = async () => {
    if (!userDetailss) {
      toast.error(
        <>
          Please <strong>login first</strong>
        </>,
        { theme: "colored" },
      );
    } else {
      const moduleList = course?.modules?.map((module) => module.id);
      console.log(course.id, moduleList, "moduleList");
      const result = await dispatch(
        addToCart({ courseId: course.id, moduleList: moduleList }),
      );
      // ).then(() => {
      //   notify();
      //   if (userDetailss) {
      //     const timeoutId = setTimeout(() => {
      //       navigate("/cart");
      //     }, 2000);
      //     return () => clearTimeout(timeoutId);
      //   }
      // });
      console.log(result, "moduleList");
      if (result.payload?.resultCode != 1) {
        callAlert("", result.payload?.message);

        return;
      } else {
        notify();
        if (userDetailss) {
          const timeoutId = setTimeout(() => {
            navigate("/cart");
          }, 2000);
          return () => clearTimeout(timeoutId);
        }
      }

      // }
      // if (userDetailss) {
      //   navigate("/cart");
      // }
    }
  };

  const handleDownloadPDF = () => {
    // const pdfURL = require('../../assets/sample.pdf');

    // // Create a link element
    // const link = document.createElement('a');
    // link.href = pdfURL;
    // link.download = 'Syllabus.pdf'; // Name of the downloaded file
    // link.click();
    downloadPdfFile(
      // `/file/syllabus/downloadFile/file?fileName=${course?.syllabusId}`,
      `/syllabus/downloadFile/file?fileName=${course?.syllabusId}`,
    );
  };

  const getYouTubeVideoId = (url) => {
    const urlObj = new URL(url);
    return urlObj.searchParams.get("v");
  };

  return (
    <>
      <style>{`
  .course-banner-wrapper .course-text-content,
  .course-banner-wrapper .course-text-content * {
    font-size: 16px !important;
    color: #ffffff !important;
  }
`}</style>
      <div className="course-banner-wrapper">
        <Container>
          <Row>
            <Col md={6}>
              <div className="banner-content">
                {/* =========Breadcrumb==== */}
                {/*     <Breadcrumb path={path} />   */}
                {/* =========Breadcrumb==== */}
                <h3 className="title-course-banner">{name}</h3>
                {/* <div className="stars-box">
                  <div className="stars">
                    <span>4.2</span>
                    <span>
                      <FaStar />
                    </span>
                    <span>
                      <FaStar />
                    </span>
                    <span>
                      <FaStar />
                    </span>
                    <span>
                      <FaStar />
                    </span>
                    <span>
                      <FaStar />
                    </span>
                  </div>
                  <div className="rating-text">
                    <span>{ratings} ratings</span>
                  </div>
                </div> */}
                <div className="key-highlights text-white key-highlights-block summery-keys course-text-content">
                  {parse(String(summary))}
                </div>

                <div className="course-banner-btns">
                  {/* <Button className="btncomponent" onClick={handleAddToCart}> */}
                  {/*  <del>₹{price}</del>  */}
                  {/* ₹{discount} */}
                  {/* <span className="ms-3"> {(((price - discount) / price) * 100).toFixed(2)}% off</span> */}
                  {/* </Button> */}

                  {userDetailss ?
                    <button
                      className="btncomponent download-btn"
                      title=" Add to cart"
                      onClick={handleAddToCart}
                    >
                      <span className="mx-2"> </span>
                      <FaCartArrowDown />₹{discount}
                    </button>
                  : <button
                      className="btncomponent download-btn"
                      title=" Add to cart"
                      onClick={() => handleAddToCartFreeTrial(course?.id)}
                      // data-bs-toggle="modal"
                      // data-bs-target="#loginModal"
                    >
                      <span className="mx-2">Free Trial</span>
                      <FaCartArrowDown />
                    </button>
                  }

                  {/* {userDetailss ?
                    <button
                      className="btncomponent download-btn"
                      title=" Add to cart"
                      onClick={handleAddToCart}
                    >
                      <span className="mx-2"> </span>
                      <FaCartArrowDown />₹{discount}
                    </button>
                  : <button
                      className="btncomponent download-btn"
                      title=" Add to cart"
                      onClick={handleAddToCart}
                      data-bs-toggle="modal"
                      data-bs-target="#loginModal"
                    >
                      <span className="mx-2">₹{discount}</span>
                      <FaCartArrowDown />
                    </button>
                  } */}

                  <Button
                    className=" btncomponent download-btn"
                    onClick={handleDownloadPDF}
                  >
                    Download Syllabus
                  </Button>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="preview-video-banner">
                <div className="video-preview-box">
                  <div className="preview-img links" onClick={handleShow}>
                    <img src={AngularImg} alt="preview img" />
                    <div className="overlay-play">
                      <div className="play-icon">
                        {/* onClick event to toggle the state */}
                        <a className="icon-box" onClick={handleShow}>
                          <FaPlay />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Modal show={show} onHide={handleClose} animation={false}>
                <Modal.Header closeButton>
                  <Modal.Title>{name} Preview course </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-1">
                  <iframe
                    width="100%"
                    height="400"
                    src={
                      "https://www.youtube.com/embed/" +
                      (course.video ?
                        getYouTubeVideoId(course.video)
                      : "IG2zSQ27VFQ")
                    }
                    title={name}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                </Modal.Body>
              </Modal>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
